"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
exports.fetchDeviceUserInfo = () => (dispatch, getState) => {
    const state = getState();
    if (state.deviceSchema.length > 0) {
        return;
    }
    dispatch({ type: 'FETCH_DEVICE_USER_INFO_REQUEST' });
    const query = graphql_tag_1.default `
            query FetchDeviceUserInfo {
                deviceUserInfoSchema {
                    keyPath
                    attributeType
                }
            }
        `;
    return Environment_1.default({ query }).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_DEVICE_USER_INFO_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_DEVICE_USER_INFO_SUCCESS',
            deviceUserInfoSchema: data.deviceUserInfoSchema,
        });
    }, ({ result }) => handleError_1.default('FETCH_DEVICE_USER_INFO_FAILURE', dispatch, result.errors[0].message));
};
